/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclEntryAccount extends models.DashboardDefinitionAclEntry {
    constructor() {
        super();
        this.setDiscriminator("account");
    }

    getFixupPrototypeFunction() { return DashboardDefinitionAclEntryAccount.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclEntryAccount>): DashboardDefinitionAclEntryAccount {
        let obj = Object.assign(new DashboardDefinitionAclEntryAccount(), model);
        DashboardDefinitionAclEntryAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclEntryAccount>): DashboardDefinitionAclEntryAccount {
        if (!model) return null;
        return DashboardDefinitionAclEntryAccount.newInstance(<DashboardDefinitionAclEntryAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclEntryAccount) {
        if (!obj) return;

        models.DashboardDefinitionAclEntryAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclEntryAccount): boolean {
        if (models.DashboardDefinitionAclEntry.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardDefinitionAclEntryAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.role_types) {
            for (let val of this.role_types) {
                models.DashboardDefinitionAclRoleType.fixupPrototype(val);
            }
        }
    }

    account_id: string;

    role_types: Array<models.DashboardDefinitionAclRoleType>;

}
